"use client"

import { motion } from "framer-motion"

export function WhatToExpect() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl md:text-3xl mb-4 text-[#3f4141] max-w-[900px] mx-auto">
            What to Expect
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {/* First Visit */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="bg-white rounded-lg p-6 lg:p-8 shadow-sm"
          >
            <h3 className="text-xl md:text-2xl font-medium mb-4 text-[#3f4141]">
              First Visit
            </h3>
            <p className="text-gray-600 font-medium mb-4">
              Your first appointment is a longer visit so there is time to:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Talk through your main concerns and health history in detail.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Look at cycles, sleep, stress, digestion and overall context – not just one symptom.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Discuss what feels realistic for you in terms of treatment frequency and support.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Begin treatment with acupuncture, and, if appropriate, discuss Chinese herbal medicine and simple lifestyle suggestions.</span>
              </li>
            </ul>
            <p className="text-gray-600 mt-4">
              The aim is for you to leave feeling listened to and clearer about the next steps.
            </p>
          </motion.div>

          {/* Ongoing Care */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white rounded-lg p-6 lg:p-8 shadow-sm"
          >
            <h3 className="text-xl md:text-2xl font-medium mb-4 text-[#3f4141]">
              Ongoing Care
            </h3>
            <p className="text-gray-600 font-medium mb-4">
              Ongoing appointments focus on:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Reviewing what has changed since your last visit.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Adjusting treatment to where you are in your cycle, fertility treatment or pregnancy timeline.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#a48b61] mt-1">•</span>
                <span>Continuing to support your nervous system, digestion and sleep over time.</span>
              </li>
            </ul>
            <p className="text-gray-600 mt-4">
              Plans are always collaborative and flexible. The goal is steady progress that fits around work, family and medical care, rather than adding extra pressure.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

